<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto dashboard-card" height="200" elevation="4">
      <template v-slot:progress>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="card-header">
        <v-icon class="mr-2" color="primary">mdi-account-arrow-right</v-icon>
        <span class="text-h6 font-weight-medium">Taxa de Evasão</span>
      </v-card-text>

      <v-row class="card-content" align="center" justify="center">
        <v-col cols="12" class="text-center">
          <div class="d-flex align-center justify-center">
            <v-card-text
              class="text-h2 font-weight-bold primary--text"
              :class="{ 'text--darken-2': parseFloat(taxa) > 10 }"
            >
              {{ taxa ?? 0 }}%
            </v-card-text>
            <v-icon v-if="parseFloat(taxa) > 10" color="red darken-2" class="ml-2">
              mdi-arrow-up
            </v-icon>
            <v-icon v-else-if="parseFloat(taxa) > 0" color="orange" class="ml-2">
              mdi-alert-circle
            </v-icon>
          </div>
          <v-card-text class="text-caption grey--text">
            {{ getEvasaoMessage() }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    franquiaId: {
      type: Number,
    },
  },
  name: "TaxaEvasao",
  mounted() {
    this.getTaxa(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.loading = true;
      this.getTaxa(value);
    },
  },
  data() {
    return {
      loading: true,
      taxa: 0,
    };
  },
  methods: {
    async getTaxa(franquiaId) {
      try {
        this.loading = true;
        const taxa = await this.$services.matriculasService.taxaEvasao(franquiaId);

        if (taxa !== undefined && taxa !== null) {
          this.taxa = parseFloat(taxa).toFixed(2);
        } else {
          this.taxa = "0.00";
        }
      } catch (error) {
        this.taxa = "0.00";
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },
    getEvasaoMessage() {
      const taxaNum = parseFloat(this.taxa);
      if (taxaNum === 0) return "Nenhuma evasão recente";
      if (taxaNum <= 5) return "Evasão controlada";
      if (taxaNum <= 10) return "Atenção à evasão";
      return "Evasão crítica!";
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border-top: 4px solid #fbbb14;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.card-header {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.card-content {
  height: calc(100% - 48px);
  display: flex;
  align-items: center;
}

.text-h2 {
  line-height: 1;
  margin-bottom: -8px;
}

.red--text {
  color: #f44336 !important;
}
.primary--text {
  color: #1976d2 !important;
}
</style>
